import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "article-list" };
const _hoisted_2 = {
    key: 0,
    class: "loading"
};
const _hoisted_3 = {
    key: 1,
    class: "empty"
};
const _hoisted_4 = { key: 2 };
const _hoisted_5 = { class: "article-title" };
const _hoisted_6 = { class: "article-meta" };
const _hoisted_7 = { class: "category" };
const _hoisted_8 = { class: "date" };
const _hoisted_9 = { class: "views" };
const _hoisted_10 = { class: "article-excerpt" };
const _hoisted_11 = { class: "article-tags" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'ArticleList',
    props: {
        articles: {},
        loading: { type: Boolean }
    },
    setup(__props) {
        /**
         * 文章列表组件
         * 展示文章摘要列表，用于首页和列表页
         */
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (__props.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, "加载中..."))
                    : (__props.articles.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "暂无文章"))
                        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.articles, (article) => {
                                return (_openBlock(), _createElementBlock("article", {
                                    key: article.id,
                                    class: "article-item"
                                }, [
                                    _createElementVNode("h2", _hoisted_5, [
                                        _createVNode(_component_router_link, {
                                            to: `/article/${article.id}`
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(article.title), 1 /* TEXT */)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                                    ]),
                                    _createElementVNode("div", _hoisted_6, [
                                        _createElementVNode("span", _hoisted_7, _toDisplayString(article.categoryName), 1 /* TEXT */),
                                        _createElementVNode("span", _hoisted_8, _toDisplayString(article.publishDate), 1 /* TEXT */),
                                        _createElementVNode("span", _hoisted_9, _toDisplayString(article.viewCount) + " 阅读", 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("p", _hoisted_10, _toDisplayString(article.excerpt), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_11, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(article.tags, (tag) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                                key: tag,
                                                class: "tag"
                                            }, _toDisplayString(tag), 1 /* TEXT */));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ]),
                                    _createVNode(_component_router_link, {
                                        to: `/article/${article.id}`,
                                        class: "read-more"
                                    }, {
                                        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                                _createTextVNode(" 阅读全文 → ", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["to"])
                                ]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]))
            ]));
        };
    }
});
